import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, Events } from 'ionic-angular';
import { HttpClient } from '../../../../services/HttpClient';
import { CustomToast } from '../../../../util/CustomToast';
import * as moment from 'moment';

@Component({
  selector: 'page-add-training',
  templateUrl: 'addTraining.html',
  providers : [HttpClient, CustomToast]
})
export class AddTrainingPage {

  modalCtrl : ModalController;
	
  httpClient : HttpClient;

  training = {
    name : '',
    date_start : '',
    date_end : '',
    place : '',
    link : '',
    description: ''
  };

  customToast : CustomToast;
  events : Events;
  filesToUpload: Array<File>;
  tags = '';

  minDate = moment().subtract(20,'years').toISOString();
  maxDate = moment().add(20,'years').toISOString();

	constructor(public navCtrl: NavController, public navParams: NavParams, httpClient : HttpClient,customToast : CustomToast,modalCtrl : ModalController, events : Events) {
		this.modalCtrl = modalCtrl;
    this.httpClient = httpClient;
    this.customToast = customToast;
    this.events = events;
    this.filesToUpload = [];
  }
  
  selectFile(fileInput: any){
    this.filesToUpload = <Array<File>> fileInput.target.files;
  }

  httpPostTraining(){
    this.httpClient.post('/trainings',this.training,(error,data)=>{
      if(!error){
        let response = data._body
        let trainingId = +(response.substring( 0, response.indexOf(",")).split('[')[1])
        if(this.filesToUpload.length>0){
          this.httpPostTrainingPdf(trainingId)
        }else{
          this.customToast.showMessage('Formación creada correctamente',2000);
        this.navCtrl.pop();
        this.events.publish('addTraining:done');
        }
        
      }
    });
  }

  httpPostTrainingPdf(trainingId:number){
    this.httpClient.upload('/trainingPdf',this.filesToUpload, this.tags, trainingId, (data: any)=>{
      this.customToast.showMessage('Oferta de trabajo creada correctamente',2000);
      this.navCtrl.pop();
      this.events.publish('addTraining:done');
    });
  }

  onClickSave(){
    this.httpPostTraining();
  }

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/trainings/addTraining/addTraining.ts